import { LoggedOutView } from '@/components/auth/LoggedOutView';
import { useAuth } from '@/main';
import { useUser } from '@clerk/clerk-react';
import { createFileRoute, useRouter } from '@tanstack/react-router';
import React from 'react';

export const Route = createFileRoute('/')({
  component: HomePage,
});

function HomePage() {
  const router = useRouter();
  const { isLoaded: authLoaded, isSignedIn } = useAuth();
  const { isLoaded: userLoaded } = useUser();

  React.useEffect(() => {
    if (authLoaded && userLoaded && isSignedIn) {
      router.navigate({ to: '/dashboard', replace: true });
    }
  }, [authLoaded, userLoaded, isSignedIn, router]);

  if (!authLoaded || !userLoaded) {
    return (
      <div className="flex min-h-svh flex-col items-center justify-center">
        <div>Loading authentication...</div>
      </div>
    );
  }

  if (!isSignedIn) {
    return <LoggedOutView />;
  }

  // If signed in, useEffect will redirect. Show a brief message.
  return (
    <div className="flex min-h-svh flex-col items-center justify-center p-2">
      <p>Redirecting to dashboard...</p>
    </div>
  );
}
